import { Button } from "@mui/material";
import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 32px;
  /* margin-bottom: 20px; */
  /* height: 431px; */
`;

export const Title = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  color: #101828;
`;

export const LightText = styled.p`
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #a3a3a6;
  margin-top: 8px;
`;

export const SpaceY: any = styled.div`
  height: ${(props: any) => props.space}px !important;
`;

export const Divider = styled.div`
  width: "100%";
  height: 20px;
  border-bottom: 2px solid #e5e5e5;
  text-align: center;
  margin-bottom: 20px;
`;

export const GradientButton = styled(Button).attrs((props) => ({
  fullWidth: true,
  disabled: props.disabled,
}))`
  background-image: linear-gradient(268.28deg, #06d986 0%, #4a76fb 100%);
  color: #ffffff !important;
  height: 40px;
  border-radius: 8px !important;
  font-family: "Inter" !important;
  font-style: normal !important;
  font-weight: 400 !important;
  font-size: 14px !important;
  line-height: 150% !important;
  text-transform: none !important;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  pointer-events: ${(props) => (props.disabled ? "none" : "auto")};
`;
